<template>
    <div class="nk-content nk-content-fluid">
        <div class="container-xl wide-lg">
            <div class="nk-content-body">
                <div class="nk-block nk-block-lg">
                    <div class="nk-block-head">
                        <div class="nk-block-between g-3">
                            <div class="nk-block-head-content">
                                <h3 class="nk-block-title page-title">Pricing Plan</h3>
                                <div class="nk-block-des text-soft">
                                    <p>Choose your pricing plan and start your earning.</p>
                                </div>
                            </div>
                        </div>
                    </div><!-- .nk-block-head -->
                    <div class="row g-gs">
                        <template v-for="details in userList">
                            <div v-bind:key="details.id" v-if="packagePlanAmount<details.amount || details.amount==100" class="col-md-6 col-xxl-3">
                                <div class="card card-bordered pricing text-center">
                                    <div class="pricing-body">
                                        <div class="pricing-media">
                                            <img src="/images/icons/plan-s1.svg" alt="">
                                            <!--<img :src="'data:image/png;base64,' + details.image" />-->
                                        </div>
                                        <div class="pricing-title w-220px mx-auto">
                                            <h5 class="title">{{details.name}}</h5>
                                            <span class="sub-text">{{details.description}}</span>
                                        </div>
                                        <div class="pricing-amount">
                                            <div class="amount">${{details.amount}}</div>
                                        </div>
                                        <div class="pricing-action">
                                            <a v-on:click="PackageBuy(details)" href="javascript:void(0)" class="btn btn-primary">Select Plan</a>
                                        </div>
                                    </div>
                                </div><!-- .pricing -->
                            </div><!-- .col -->

                        </template>
                    </div>
                </div><!-- .nk-block -->
            </div>
        </div>
        <loading :name="loading" :active.sync="loading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>

</template>
<script>
    import Loading from 'vue-loading-overlay';
    import "vue-loading-overlay/dist/vue-loading.css";
    export default {
        components: {
            Loading
        },
        name: 'PackageList',
        data: function () {
            return {
                packagePlanAmount: 0,
                loading: false,
                userList: [],

            }
        },
        methods: {
            
            AddSignup: function () {
                this.$router.push('/AddPackagePrice')
            },

            GetData: function () {
                var root = this;
                var url = '/Company/PackagePriceList?isDropDown=true';
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                this.loading = true;
                root.$https.get(url, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        root.userList = response.data.results;
                        root.loading = false;
                    }
                }).catch(error => {
                    console.log(error)
                    root.loading = false;
                    root.$swal.fire({
                            icon: 'error',
                            type: 'error',
                            title: 'Error',
                            text: "Something Went Wrong",
                            showConfirmButton: false,
                            timer: 5000,
                            timerProgressBar: true,
                        });
                }).finally(() => root.loading = false);
            },


            PackageBuy: function (value) {
                var root = this;
                root.$router.push({
                    path: '/Deposit',
                    query: { data: value }
                });
            },

        },
        created: function () {
            this.packagePlanAmount = parseFloat(localStorage.getItem('PackagePlanAmount'));

            this.GetData();
        },
        mounted: function () {
            
        },
    }
</script>